import styled from "styled-components";

import { Link as LinkComponent } from "@components/Navigation/Link";

export const Nav = styled.nav`
  font-size: 0;
  align-self: flex-end;
`;

export const List = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
`;

export const Link = styled(LinkComponent)`
  padding-left: ${props => props.theme.spacing.spacing_12};
  padding-right: ${props => props.theme.spacing.spacing_12};
`;
